import { TreeCardObject } from '../tree-card/tree-card-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderStatusObject } from '../order-status-object.model';
import { OrderTypeObject } from '../order-type-object.model';

export class RfsOrderObject extends TreeCardObject {

  constructor(name: string, completed: boolean, crmId: string, operation: string,
    status: string, dependencies: boolean, orderId: string) {
    super(name, 'ORDEN DE RECURSO (RFS)', StringUtils.NOT_AVALIABLE, completed, crmId, operation,
      OrderStatusObject.createWithStatus(status), dependencies, 4, orderId, OrderTypeObject.RFS);
    return this;
  }
}
